module.exports = "https://cdn.hellotech.com/client-assets/virtual-services-mobile_13d70b6301813efbad421c0d62936d99.png";